/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_CenterInputs */



/**
* | output |
* | --- |
* | "Center" |
*
* @param {Input_Position_X_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_center = /** @type {((inputs?: Input_Position_X_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Center")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中心")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro")
	return /** @type {LocalizedString} */ ("Center")
});